import PropTypes from "prop-types";
import pluralize from "pluralize";
import { last } from "ramda";

import Presenter from "utils/PropTypesPresenter";
import TemplateGroupPresenter from "presenters/TemplateGroupPresenter";
import { appRoutes } from "routes";
import { DeviceTypeToTemplateGroupType, TEMPLATE_GROUP_TYPE_THUMB_ASPECT_RATIO } from "enums/templateGroup";
import { jjLogger } from "utils/logUtils";

export default new Presenter(
  {
    id: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
    type: PropTypes.string,
    ghostThumbnail: PropTypes.string,
    templateGroupType: PropTypes.string,
    previewPoster: PropTypes.string,
    previewPoster169: PropTypes.string,
    coverImage: PropTypes.string,
    titleImage: PropTypes.string,
    previewVideo: PropTypes.string,
  },

  {
    thumb(tg) {
      return this.ghostThumbnail(tg);
    },

    castNumOptions(tg) {
      return TemplateGroupPresenter.castNumOptions(tg);
    },

    castsCount(tg) {
      const { castNumOptions } = tg;
      return castNumOptions[0];
    },

    allCardsCount(items) {
      return items && items.length;
    },
    isStraightUp(tg) {
      return TemplateGroupPresenter.isStraightUp(tg);
    },
    isStarringYouClip(tg) {
      return TemplateGroupPresenter.isStarringYouClip(tg);
    },
    isStarringYouVertical(tg) {
      return TemplateGroupPresenter.isStarringYouVertical(tg);
    },
    isStarringYou(tg) {
      return TemplateGroupPresenter.isStarringYou(tg);
    },
    isStarringYouInvite(tg) {
      return TemplateGroupPresenter.isStarringYouInvite(tg);
    },
    isStarringYouInviteGif(tg) {
      return TemplateGroupPresenter.isStarringYouInviteGif(tg);
    },
    isInvite(tg) {
      return TemplateGroupPresenter.isInvite(tg);
    },
    isStarringYouAI(tg) {
      return TemplateGroupPresenter.isStarringYouAI(tg);
    },
    handleRedirect(tg) {
      const slug = tg.id;

      if (this.isInvite(tg)) return appRoutes.invitesPreviewPath(slug);
      if (this.isStarringYouAI(tg)) return appRoutes.morphablePackGroupPath(slug);

      return appRoutes.templateGroupPath(slug);
    },
    posterUrl(tg) {
      if (this.previewPoster169(tg)) return this.previewPoster169(tg);
      if (this.previewPoster(tg)) return this.previewPoster(tg);
      if (this.coverImage(tg)) return this.coverImage(tg);

      return this.thumb(tg);
    },
    formatCastOptions(tg, separator = "-") {
      const lastOption = last(this.castNumOptions(tg));
      const firstOption = this.castNumOptions(tg)[0];
      if (lastOption !== firstOption) return `${firstOption}${separator}${lastOption} People`;
      return `${firstOption} ${pluralize("Person", firstOption)}`;
    },
    deviceType(tg) {
      return DeviceTypeToTemplateGroupType[this.templateGroupType(tg)];
    },
    heightFromAspectRatio(tg, width) {
      if (!Object.hasOwn(TEMPLATE_GROUP_TYPE_THUMB_ASPECT_RATIO, this.templateGroupType(tg))) {
        jjLogger.logError(`Template group type ${this.templateGroupType(tg)} has no aspect ratio defined`);
        return 0;
      }

      const [widthRatio, heightRatio] = TEMPLATE_GROUP_TYPE_THUMB_ASPECT_RATIO[this.templateGroupType(tg)].split("/");
      return (width * heightRatio) / widthRatio;
    },
  },
);
